import { useMutation } from '@tanstack/react-query';

import { DemioRegisterRequest, DemioRegisterResponse, registerDemioEvent } from '@arrived/api_v2';

import { UseMutationOptions } from '../queries.utils';

export function useRegisterDemioEventMutation(
  options?: UseMutationOptions<DemioRegisterResponse, DemioRegisterRequest>
) {
  return useMutation((request) => registerDemioEvent(request), options);
}
